import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const formSchema = z
  .object({
    link: z.string().optional(),
    fileUrl: z.string().optional(),
    isTeamsApp: z.boolean().optional(),
    isSellersApp: z.boolean().optional(),
    isWebApp: z.boolean().optional(),
    file: z.custom<File | null>(),

    title: z.string().optional(),
    description: z.string().optional(),
    buttonLabel: z.string().optional(),
    isYoutubeVideo: z.boolean().optional(),
    videoUrl: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.fileUrl && !data.file && !data.videoUrl) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'O arquivo é obrigatório.',
        path: ['file'],
      })
    }
  })

export type BannerFormValues = z.infer<typeof formSchema>

interface UseBannerFormProps {
  defaultValues?: BannerFormValues
}

const initialData: BannerFormValues = {
  file: null,
  link: '',
  title: '',
  description: '',
  buttonLabel: '',
  isYoutubeVideo: false,
  videoUrl: '',
  isTeamsApp: false,
  isSellersApp: false,
  isWebApp: false,
}

export default function useBannerForm({ defaultValues }: UseBannerFormProps) {
  return useForm<BannerFormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: defaultValues ?? initialData,
  })
}
